import { IBillingFormValues } from '@jpp/organisms/CheckoutForm/components/BillingFormFields/BillingFormFields';
import { IShippingFormValues } from '@jpp/organisms/CheckoutForm/components/DeliveryFormFields/DeliveryFormFields';
import { IOrderLineItem } from 'common/utils/shared/orders';

export enum EBillingAddress {
  Shipping = 'Shipping',
  Billing = 'Billing',
}

export enum ECheckoutStep {
  Cart = 'cart',
  Login = 'login',
  Delivery = 'delivery',
  Payment = 'payment',
  Register = 'register',
}

export interface ICheckoutFormValues
  extends IBillingFormValues,
    IShippingFormValues {
  has_only_virtual_products?: boolean;
  payment_method: string;
  payment_method_title: string;
  set_paid: boolean;
  marketing_opt_in: boolean;
  save_card: boolean;
  alternate_billing_address: EBillingAddress | string;
  line_items: IOrderLineItem[];
  email: string;
  phone: string;
  errorMessage?: string;
  paymentErrorMessage?: string;
  submittedMessage?: string;
  cardValid: string;
  savedPaymentMethod?: string;
  username?: string;
  password?: string;
  confirmPassword?: string;
}
